import { computed, inject } from '@angular/core';
import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';

import { UniversalHelpersClass } from '@senet-uiverse/common';
import { ToastService } from '@senet-uiverse/ui';
import { EMPTY } from 'rxjs';

import {
  OrganizationService,
  DocumentsService,
  BookingService,
  ProfileService,
  StorageService,
  PassesService,
  TitleService,
} from './core/services';

export default abstract class SenetIdUniversalClass extends UniversalHelpersClass {
  private readonly titleService = inject(TitleService);

  readonly organizationService = inject(OrganizationService);
  readonly documentsService = inject(DocumentsService);
  readonly storageService = inject(StorageService);
  readonly profileService = inject(ProfileService);
  readonly bookingService = inject(BookingService);
  readonly passesService = inject(PassesService);
  readonly toastService = inject(ToastService);

  readonly hasBonusBalance = computed(() => Boolean(this.storage().organizationInfo?.has_bonus_balance));
  readonly organizationTitle = this.organizationService.selectedOrganizationTitle;
  readonly storage = this.storageService.storage;

  changeTitle(title: Readonly<string>) {
    this.titleService.change(title);
  }

  openDialog<T>(component: Promise<any>, context: Readonly<any> = {}) {
    return this.dialog.open<T>({
      component,
      config: {
        closeOnBackdropClick: false,
        closeOnEsc: false,
        context,
      },
      isObservable: true,
      successOnly: true,
    });
  }

  catchError(errorResponse: Readonly<HttpErrorResponse>) {
    if (errorResponse.error?.detail) {
      this.toastService.danger({ message: errorResponse.error.detail });
    } else if (errorResponse.status === HttpStatusCode.InternalServerError) {
      this.toastService.danger({
        title: this.translateService.instant('common.request.error.title'),
        message: this.translateService.instant('common.request.error.description'),
      });
    }

    return EMPTY;
  }
}
